import { VideoLayerManager } from "@manager/scenarioRunner/layerManager/VideoLayerManager";
import { Loop } from "../../../model/playerConfiguration/Loop";

export class Looper {
  private loop?: Loop;
  private previousVolume = 0;

  constructor(private videoLayerManager: VideoLayerManager) {}

  get isLooping() {
    return !!this.loop;
  }

  start(loop: Loop) {
    this.loop = loop;
    this.previousVolume = this.videoLayerManager.getVolume();

    this.videoLayerManager.changeMuted(true);
    this.videoLayerManager.moveTo(loop.start);
    this.videoLayerManager.play();
  }

  stop() {
    if (!this.loop) {
      return;
    }

    if (this.loop.jumpToOnPlay != null) {
      this.videoLayerManager.moveTo(this.loop.jumpToOnPlay);
    }

    this.videoLayerManager.changeMuted(false);
    this.videoLayerManager.changeVolume(this.previousVolume);
    this.loop = undefined;
  }

  update() {
    if (!this.loop) {
      return;
    }

    if (this.videoLayerManager.getCurrentSeekTime() >= this.loop.start + this.loop.duration) {
      this.videoLayerManager.moveTo(this.loop.start);
    }
  }
}
